<motif-header [fixed]="true" appHeaderName="MS Control Tower">
  <!-- Logo -->
  <motif-header-logo>
    <a routerLink="/" aria-label="Home Page">
      <img src="./assets/images/ey-logo-inverted.svg" alt="EY Logo"/>
    </a>
  </motif-header-logo>
  <!-- Menu -->
  <button
    *ngIf="isLoggedIn"
    (click)="menuToggleHandler()"
    motifIconButton aria-label="Open Main Menu" placement='left'>
    <motif-icon [src]="'/assets/icons/navigation/ic_menu_24px.svg'"></motif-icon>
  </button>

  <div *ngIf="isLoggedIn && userService.userDetails" motif-header-avatar>
    <div class="user-info" motifDropdown placement="bottom-right"
         (openChange)="onUserInfoOpen($event, dropDownMenuElementRef)">
      <div class="user-box display-flex align-items-center" motifDropdownToggle>
        <motif-avatar size="small"
                      [src]="$any(userService.userDetails?.pictureBase64)"
                      [userName]="$any(userService.userDetails?.displayName)">
        </motif-avatar>
      </div>
      <div class="user-menu-list" motifDropdownMenu #dropDownMenuElementRef>
        <div motifDropdownItem class="avatar-dropdown-item">
          <motif-avatar size="large"
                        [src]="$any(userService.userDetails?.pictureBase64)"
                        [userName]="$any(userService.userDetails?.displayName)">
          </motif-avatar>
          <h3>{{ userService.userDetails?.displayName }}</h3>
        </div>
        <button class="logout-btn" (click)="logout()" motifDropdownItem>
          <motif-icon [src]="'/assets/icons/action/ic_exit_to_app_24px.svg'"></motif-icon>
          Logout
        </button>
      </div>
    </div>
  </div>
</motif-header>
